export const FLOW_COMMENTS_SIZE = 10;
